import styled from "styled-components/macro";
import { media } from "../../utils";

export const ImageContent = styled.div`
  width: 100%;
  text-align: center;
  margin-bottom: 26px;
  ${media.md()} {
    display: none;
  }
`;

export const AreaDoCliente = styled.a`
  width: 100%;
  ${media.md()} {
    width: 184px;
  }
`;
